import { CONSENT_EVENT, CONSENT_KEY, readConsent, isAnalyticsEnabled } from './consent';

export const MEASUREMENT_ID = 'G-V6F9420XVK';
const DISABLE_KEY = `ga-disable-${MEASUREMENT_ID}`;
const DENIED = { analytics_storage: 'denied', ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied' };

function clearAnalyticsCookies() {
  const domains = ['', window.location.hostname, 'cursivefont.org'];
  for (const name of ['_ga', '_ga_V6F9420XVK']) {
    for (const domain of domains) {
      document.cookie = `${name}=; Max-Age=0; path=/${domain ? `; domain=${domain}` : ''}`;
    }
  }
}

// Analytics is on by default; a saved opt-out stops collection.
// GA4's enhanced measurement handles history changes; do not double-send page_view.
export function mountGoogleAnalytics() {
  if (typeof window === 'undefined') return () => {};
  window[DISABLE_KEY] = true;
  if (!['cursivefont.org', 'www.cursivefont.org'].includes(window.location.hostname)) return () => {};
  let tag;
  let configured = false;
  let active = false;
  let disposed = false;
  let timer;
  const disable = () => {
    window[DISABLE_KEY] = true;
    if (active && window.gtag) window.gtag('consent', 'update', { ...DENIED });
    active = false;
    clearAnalyticsCookies();
    if (tag && !configured) {
      tag.onload = null;
      tag.onerror = null;
      tag.remove();
      tag = null;
    }
  };
  const sync = () => {
    clearTimeout(timer);
    const consent = readConsent();
    if (!disposed && consent) timer = setTimeout(sync, Math.min(consent.expiresAt - Date.now() + 1, 86400000));
    if (disposed || !isAnalyticsEnabled(consent)) { disable(); return; }
    window[DISABLE_KEY] = false;
    if (configured) {
      if (!active) window.gtag('consent', 'update', { ...DENIED, analytics_storage: 'granted' });
      active = true;
      return;
    }
    if (tag) return;
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function gtag() { window.dataLayer.push(arguments); };
    window.gtag('consent', 'default', { ...DENIED });
    tag = document.createElement('script');
    tag.async = true;
    tag.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
    tag.dataset.googleAnalytics = MEASUREMENT_ID;
    tag.onload = () => {
      if (disposed || configured || !isAnalyticsEnabled(readConsent())) { sync(); return; }
      configured = true;
      active = true;
      window.gtag('consent', 'update', { ...DENIED, analytics_storage: 'granted' });
      window.gtag('js', new Date());
      window.gtag('config', MEASUREMENT_ID, {
        allow_google_signals: false,
        allow_ad_personalization_signals: false,
        cookie_expires: 180 * 24 * 60 * 60,
      });
    };
    tag.onerror = () => { tag?.remove(); tag = null; window[DISABLE_KEY] = true; };
    document.head.appendChild(tag);
  };
  const storage = event => { if (event.key === CONSENT_KEY || event.key === null) sync(); };
  window.addEventListener(CONSENT_EVENT, sync);
  window.addEventListener('storage', storage);
  window.addEventListener('focus', sync);
  sync();
  return () => {
    disposed = true;
    clearTimeout(timer);
    window.removeEventListener(CONSENT_EVENT, sync);
    window.removeEventListener('storage', storage);
    window.removeEventListener('focus', sync);
    disable();
    if (tag) { tag.onload = null; tag.onerror = null; tag.remove(); }
  };
}
